import type { Plan } from '../api/queries'
import type { MessageId } from '../i18n'

export const PLAN_LABEL: Record<Plan, MessageId> = {
  free: 'plan.free',
  trial: 'plan.trial',
  pro: 'plan.pro',
  enterprise: 'plan.enterprise',
}
